import React from 'react';
import { Button, Navbar } from 'react-bootstrap';
import { bootstrapUtils } from 'react-bootstrap/lib/utils';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import setupNotifications from './setupNotifications';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../node_modules/croppie/croppie.css';
import Routes from './routes';
import rootSaga from './state/rootSaga';
import store, { history } from './state/store';
import './tmp/style.css';
rootSaga.run();
setupNotifications();
bootstrapUtils.addStyle(Button, 'plain');
bootstrapUtils.addStyle(Button, 'green');
bootstrapUtils.addStyle(Navbar, 'footer');
const rootElement = document.getElementById('root');
if (rootElement) {
    ReactDOM.render(React.createElement(Provider, { store: store },
        React.createElement(ConnectedRouter, { history: history },
            React.createElement("div", null,
                React.createElement(Routes, null),
                React.createElement(ToastContainer, null)))), rootElement);
}



//////////////////
// WEBPACK FOOTER
// ./src/index.tsx
// module id = 937
// module chunks = 0